import React from 'react';
import { Button } from 'primereact/button';

const ManualSwitchBackButton = () => {
    // Only show if impersonating
    const isImpersonating = localStorage.getItem('isImpersonating') === 'true';
    
    if (!isImpersonating) {
        return null;
    }

    const handleSwitchBack = () => {
        try {
            console.log('Manually switching back to admin...');
            
            // Restore admin context
            const originalToken = localStorage.getItem('originalAdminToken');
            const originalUser = localStorage.getItem('originalAdminUser');
            
            if (originalToken && originalUser) {
                localStorage.setItem('authToken', originalToken);
                localStorage.setItem('user', originalUser);
                localStorage.setItem('isAuthenticated', 'true');
                
                // Clear impersonation data
                localStorage.removeItem('isImpersonating');
                localStorage.removeItem('originalAdminToken');
                localStorage.removeItem('originalAdminUser');
                localStorage.removeItem('impersonatedUserId');
                localStorage.removeItem('impersonatedUserName');
                localStorage.removeItem('originalAdminInfo');
                
                // Redirect to admin users page
                window.location.href = '/app/admin/users';
            } else {
                console.error('Could not find original admin data');
                alert('Error: Could not restore admin session');
            }
        } catch (error) {
            console.error('Switch back failed:', error);
            alert('Error switching back to admin');
        }
    };

    const impersonatedUserName = localStorage.getItem('impersonatedUserName') || 'Unknown User';

    return (
        <Button
            label="Switch Back to Admin"
            icon="pi pi-arrow-left"
            onClick={handleSwitchBack}
            className="p-button-danger"
            style={{
                position: 'fixed',
                bottom: '20px',
                left: '20px',
                zIndex: 10001,
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
            }}
        />
    );
};

export default ManualSwitchBackButton;